const PLAN_PURCHASE_VALUE = {
  START_VERIFICADO: 47,
  PRO_VERIFICADO: 97,
}

export function trackMeta(event, params = {}) {
  if (typeof window.fbq !== 'function') return
  window.fbq('track', event, params)
}

export function trackPurchase(planoCodigo, extra = {}) {
  const value = PLAN_PURCHASE_VALUE[planoCodigo]
  if (!value) return
  trackMeta('Purchase', { value, currency: 'BRL', content_ids: [planoCodigo], ...extra })
}

export function trackPurchaseOnce(dedupeKey, planoCodigo, extra = {}) {
  const key = `meta_purchase_${dedupeKey}`
  if (sessionStorage.getItem(key)) return
  trackPurchase(planoCodigo, extra)
  sessionStorage.setItem(key, '1')
}
